import { Component, input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { take } from 'rxjs';
import { AuctionService } from '../../services/AuctionService';
import { PropertyBidHistoryAnonymized } from '../../models/propertyBidHistoryAnonymized';

/**
 * Bid history of a property for users who may not see the full (admin) history, e.g. client users:
 * one tab per auction sequence with the masked bids of the public view (no bidder details, no actions).
 * Loads once (no live updates), like the admin history in the bidding history dialog.
 */
@Component({ standalone: false,
  selector: 'app-bidding-history-anonymized',
  templateUrl: './bidding-history-anonymized.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bidding-history-anonymized.component.scss']
})
export class BiddingHistoryAnonymizedComponent {
  readonly propertyId = input<number|undefined>(undefined);
  readonly auctionType = input<number|undefined>(undefined);

  public propertyBidHistory?:PropertyBidHistoryAnonymized;
  public busy:boolean=false;

  constructor(private auctionService:AuctionService, private cdRef:ChangeDetectorRef) {
  }

  ngOnInit(){
    this.getPropertyBidHistory();
  }

  private getPropertyBidHistory(){
    if(!this.propertyId()) return;
    this.busy=true;
    this.auctionService.getPropertyBidHistoryAnonymized(this.propertyId()!).pipe(take(1)).subscribe(pbh=>{
      this.propertyBidHistory=pbh;
      this.busy=false;
      this.cdRef.detectChanges();
    });
  }
}
